import * as React from 'react';
import type { SVGProps } from 'react';
import { chakra } from '@chakra-ui/react';
const SvgIconMelbourneMinimapMarkers = chakra(
  (props: SVGProps<SVGSVGElement>) => (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={376}
      height={375}
      fill="none"
      viewBox="0 0 376 375"
      aria-hidden="true"
      {...props}
    >
      <g clipPath="url(#icon-melbourne-minimap-markers_svg__a)">
        <path
          fill="url(#icon-melbourne-minimap-markers_svg__b)"
          fillOpacity={0.2}
          stroke="#fff"
          strokeOpacity={0.1}
          strokeWidth={10}
          d="M59.978 135.947c1.432 4.664-2.086 7.498-4.089 8.263l-4.117 1.974-11.27 5.402c-4.386 2.649-2.639 4.896-1.776 6.277 5.833 7.12 12.102 13.808 18.506 19.919 7.606 7.257 15.403 13.699 22.888 19.079 18.114 13.021 29.321 17.529 32.898 19.46 9.206 4.972 10.74 8.105 13.071 12.863l.027.055c1.849 4.372 1.434 9.165.809 12.581-.286 1.559-.615 2.831-.792 3.644-.305 1.402-.129 2.413.347 3.176.406.651 1.031 1.122 1.763 1.5.587.304 8.242 4.825 17.864 10.532 16.42 9.739 38.568 22.932 41.097 24.512 4.01 2.506 55.138 32.938 63.34 38.057.658.411 1.272.811 1.869 1.187 2.59 1.632 4.847 2.805 8.848 2.372 4.671-.506 7.413-4.661 7.757-5.294 1.722-3.168 3.485-6.651 5.071-9.816.818-1.633 1.589-3.181 2.283-4.558 2.037-4.044 5.113-.994 5.51-.635.097.087.634.576 1.423 1.301 2.456 2.255 7.362 6.8 9.114 8.674 1.263 1.349 3.686 4.042 6.443 6.973 2.304 2.449 4.841 5.065 7.129 7.204 1.75 1.635 4.188 3.566 6.827 3.935 3.431.48 7.066-.971 8.569-1.873a2076.83 2076.83 0 0 1 11.65-6.611c6.363-3.582 13.035-7.288 16.998-9.362 1.515-.792 2.634-1.347 3.19-1.564 3.002-1.177 2.937-3.327 2.529-4.255-.245-.961-1.176-3.048-2.611-5.928-2.765-5.553-7.4-14.052-12.585-23.11-4.337-7.577-9.06-15.544-13.396-22.504-12.208-19.594-27.379-22.442-29.202-23.526-1.824-1.083-8.017-3.119-18.351-9.261-2.327-1.383-4.609-2.273-6.749-2.811-5.464-1.371-10.008-.442-12.031.467-2.065.411-5.573 2.551-9.822 3.388-1.455.287-2.996.421-4.596.281-1.107-.146-3.941-.871-7.844-2.634a58.418 58.418 0 0 1-3.597-1.779c-5.737-3.081-13.085-6.818-16.042-8.301-9.751-5.184-17.666-11.555-24.833-22.574-18.428-28.331-8.817-57.088-6.978-74.066 1.813-16.738-6.076-31.99-6.076-31.99s-4.774-10.652-7.099-15.735c-2.325-5.084-7.813-12.458-17.777-17.146-12.781-4.84-16.846-2.733-26.461-1.36-7.122 1.017-12.861-1.43-16.503-3.348-1.275-.672-2.293-1.279-3.023-1.65-2.113-1.072-5.411.495-6.661 2.211-1.2 1.648-2.699 3.279-4.408 4.885-4.924 4.63-11.587 9.063-17.83 13.156-6.727 4.41-12.596 9.977-14.018 11.821-4.127 4.577-12.864 15.14-15.084 17.768-2.22 2.629-1.549 6.757-.935 8.493l4.19 14.526 4.546 15.755Z"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M146.105 260.672c16.421 9.74 38.569 22.932 41.098 24.512 4.01 2.506 55.138 32.939 63.339 38.057.658.411 1.273.811 1.87 1.188"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M252.414 324.428c2.589 1.631 4.846 2.805 8.847 2.372 4.671-.506 7.413-4.661 7.757-5.294 1.722-3.169 3.485-6.651 5.071-9.816"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M274.089 311.691c.818-1.633 1.589-3.182 2.282-4.558 2.037-4.045 5.113-.995 5.511-.636.097.087.633.576 1.423 1.301"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M283.306 307.798c2.455 2.255 7.361 6.799 9.114 8.674 1.262 1.349 3.685 4.041 6.443 6.973"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M305.993 330.649c-2.289-2.139-4.826-4.755-7.13-7.204"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M305.992 330.649c1.75 1.635 4.187 3.566 6.827 3.935"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M312.818 334.585c3.43.479 7.065-.972 8.568-1.874 3.098-1.772 7.302-4.162 11.65-6.611"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="M333.038 326.1c6.363-3.582 13.034-7.288 16.998-9.362"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M350.035 316.738c1.515-.793 2.634-1.347 3.19-1.564 3.002-1.177 2.937-3.327 2.528-4.255-.244-.961-1.175-3.048-2.61-5.928"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M353.143 304.991c-2.765-5.552-7.4-14.052-12.585-23.11"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M340.559 281.88c-4.338-7.576-9.06-15.544-13.396-22.503-12.209-19.595-27.379-22.442-29.203-23.526-1.823-1.084-8.016-3.119-18.35-9.261-2.327-1.383-4.609-2.274-6.75-2.811"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M272.86 223.779c-5.464-1.371-10.008-.442-12.031.467-2.065.411-5.573 2.551-9.822 3.388"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M251.006 227.635c-1.454.286-2.996.42-4.596.28-1.106-.146-3.941-.87-7.844-2.634"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M238.567 225.281a58.71 58.71 0 0 1-3.598-1.779c-5.736-3.081-13.085-6.818-16.042-8.301-9.751-5.184-17.665-11.555-24.832-22.574-18.428-28.331-8.818-57.088-6.979-74.066 1.813-16.738-6.075-31.99-6.075-31.99s-4.774-10.651-7.099-15.735-7.813-12.458-17.777-17.146c-12.782-4.84-16.846-2.733-26.461-1.36-7.122 1.017-12.861-1.43-16.503-3.348"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M103.517 49.543c1.25-1.716 4.548-3.283 6.661-2.21.73.37 1.748.977 3.023 1.649"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M103.517 49.543c-1.199 1.648-2.699 3.279-4.408 4.886"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M99.11 54.428c-4.925 4.63-11.588 9.063-17.83 13.155-6.728 4.41-12.597 9.978-14.018 11.822-4.128 4.577-12.865 15.14-15.085 17.768-2.22 2.628-1.548 6.757-.935 8.492l4.191 14.527"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="m59.979 135.946-4.545-15.754"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M55.89 144.21c2.002-.765 5.52-3.599 4.088-8.263"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="m55.89 144.21-4.118 1.974"
        />
        <path
          stroke="#CCC"
          strokeLinecap="round"
          strokeWidth={4}
          d="m40.502 151.586 11.27-5.402"
        />
        <path
          stroke="#00FF2B"
          strokeLinecap="round"
          strokeWidth={4}
          d="M40.502 151.586c-4.385 2.649-2.638 4.896-1.776 6.277"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M38.726 157.864c5.833 7.119 12.101 13.808 18.505 19.918"
        />
        <path
          stroke="#FF5252"
          strokeLinecap="round"
          strokeWidth={4}
          d="M57.231 177.782c7.606 7.257 15.403 13.699 22.888 19.079 18.115 13.022 29.322 17.529 32.898 19.461 9.242 4.991 10.753 8.128 13.099 12.918 1.849 4.371 1.433 9.164.808 12.58"
        />
        <path
          stroke="#00FFE8"
          strokeLinecap="round"
          strokeWidth={4}
          d="M128.243 250.14c-.732-.379-1.357-.849-1.763-1.5-.476-.763-.652-1.774-.347-3.176.178-.814.507-2.085.792-3.644"
        />
        <path
          stroke="#FFC107"
          strokeLinecap="round"
          strokeWidth={4}
          d="M126.48 248.64c.407.651 1.032 1.121 1.763 1.5.587.304 8.242 4.825 17.864 10.532"
        />
        <g filter="url(#icon-melbourne-minimap-markers_svg__c)">
          <path
            fill="#fff"
            fillOpacity={0.95}
            d="m180.04 263.938 2.848 2.848-3.2 3.2-2.848-2.848zM173.64 270.338l2.848 2.848-3.2 3.2-2.848-2.848zM167.239 276.739l2.848 2.848-3.2 3.2-2.848-2.848zM160.839 283.139l2.848 2.848-3.2 3.2-2.848-2.848zM154.438 289.539l2.848 2.848-3.2 3.2-2.848-2.848zM179.688 269.986l2.848 2.848-3.2 3.2-2.848-2.848zM173.288 276.386l2.848 2.848-3.2 3.2-2.848-2.848zM166.887 282.787l2.848 2.848-3.2 3.2-2.848-2.848zM160.486 289.187l2.848 2.848-3.2 3.2-2.848-2.848z"
          />
          <path
            fill="#000"
            d="m182.889 266.786 2.848 2.848-3.2 3.2-2.848-2.848zM176.488 273.186l2.848 2.848-3.2 3.2-2.848-2.848zM170.088 279.587l2.848 2.848-3.2 3.2-2.848-2.848zM163.687 285.987l2.848 2.848-3.2 3.2-2.848-2.848zM157.286 292.388l2.848 2.848-3.2 3.2-2.848-2.848zM176.84 267.138l2.848 2.848-3.2 3.2-2.848-2.848zM170.439 273.538l2.848 2.848-3.2 3.2-2.848-2.848zM164.039 279.939l2.848 2.848-3.2 3.2-2.848-2.848zM157.639 286.339l2.848 2.848-3.2 3.2-2.848-2.848z"
          />
          <path
            fill="#E2645A"
            d="m128.906 278.398 3.51 17.448 13.973-13.973-17.483-3.475Zm-1.6-1.601c.515-.515 1.207-.784 1.904-.636l18.305 3.68c1.429.262 1.8 2.005.667 3.138l-14.694 14.694c-1.099 1.099-2.877.763-3.173-.632l-3.645-18.339a2.208 2.208 0 0 1 .636-1.905Z"
          />
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__d)">
          <rect
            width={20}
            height={20}
            x={94.5}
            y={243}
            fill="url(#icon-melbourne-minimap-markers_svg__e)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__f)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m104.327 250.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__g)">
          <rect
            width={20}
            height={20}
            x={124.5}
            y={192}
            fill="url(#icon-melbourne-minimap-markers_svg__h)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__i)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m131.505 204.236 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V206h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__j)">
          <rect
            width={20}
            height={20}
            x={7.5}
            y={138}
            fill="url(#icon-melbourne-minimap-markers_svg__k)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__l)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M14.287 150.764v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L19.05 152h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__m)">
          <rect
            width={20}
            height={20}
            x={67.5}
            y={132}
            fill="url(#icon-melbourne-minimap-markers_svg__n)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__o)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M78.207 144.392h-4.08v-1.572l3.684-5.22H79.6v5.592h1.02v1.2H79.6V146h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__p)">
          <rect
            width={20}
            height={20}
            x={25.5}
            y={72}
            fill="url(#icon-melbourne-minimap-markers_svg__q)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__r)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M32.39 84.764V83.54h1.391v.804l.468.456h2.256l.468-.456V82.28l-.468-.468H32.51V77.6h5.688v1.2h-4.32v1.812h3.24l1.248 1.248v2.904L37.13 86h-3.504l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__s)">
          <rect
            width={20}
            height={20}
            x={112.5}
            y={19}
            fill="url(#icon-melbourne-minimap-markers_svg__t)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__u)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M119.409 31.764v-5.928l1.236-1.236h3.528l1.236 1.236v1.104h-1.392v-.66l-.48-.48h-2.256l-.48.48v2.256l.792-.78h2.628l1.236 1.236v2.772L124.221 33h-3.576l-1.236-1.236Zm4.176.036.48-.48v-1.884l-.48-.48h-1.8l-.984 1.008v1.356l.48.48h2.304Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__v)">
          <rect
            width={20}
            height={20}
            x={196.5}
            y={99}
            fill="url(#icon-melbourne-minimap-markers_svg__w)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__x)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M203.256 111.764v-2.34l.756-.756-.636-.636v-2.196l1.236-1.236h3.528l1.236 1.236v2.196l-.636.636.756.756v2.34L208.26 113h-3.768l-1.236-1.236Zm4.248-3.612.48-.48v-1.392l-.48-.48h-2.256l-.48.48v1.392l.48.48h2.256Zm.12 3.648.48-.48v-1.524l-.48-.468h-2.496l-.48.468v1.524l.48.48h2.496Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__y)">
          <rect
            width={20}
            height={20}
            x={139.5}
            y={65}
            fill="url(#icon-melbourne-minimap-markers_svg__z)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__A)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M150.661 72.028V71.8h-4.248v-1.2h5.688v1.464L148.753 79h-1.464l3.372-6.972Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__B)">
          <rect
            width={20}
            height={20}
            x={238.5}
            y={237}
            fill="url(#icon-melbourne-minimap-markers_svg__C)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__D)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="M245.44 249.764v-1.02h1.392v.576l.48.48h2.184l.48-.48v-2.172l-.744.744h-2.676l-1.236-1.236v-2.82l1.236-1.236h3.576l1.236 1.236v5.928L250.132 251h-3.456l-1.236-1.236Zm3.648-3.072.888-.888v-1.524l-.48-.48h-2.304l-.48.48v1.932l.48.48h1.896Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__E)">
          <rect
            width={20}
            height={20}
            x={276.5}
            y={198}
            fill="url(#icon-melbourne-minimap-markers_svg__F)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__G)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m282.341 205.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.262 5.592v-5.736l1.332-1.332h3.624l1.332 1.332v5.736L290.559 212h-3.624l-1.332-1.332Zm4.308.132.588-.576v-4.848l-.588-.576h-2.328l-.588.576v4.848l.588.576h2.328Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__H)">
          <rect
            width={20}
            height={20}
            x={346.5}
            y={330}
            fill="url(#icon-melbourne-minimap-markers_svg__I)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__J)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m353.958 337.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm4.738 0-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__K)">
          <rect
            width={20}
            height={20}
            x={285.5}
            y={338}
            fill="url(#icon-melbourne-minimap-markers_svg__L)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__M)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m291.803 345.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.071 5.16 4.344-4.056v-.924l-.468-.456h-2.064l-.468.456v.78h-1.392v-1.2l1.236-1.236h3.312l1.236 1.236v1.752l-4.308 3.972v.252h4.356V352h-5.784v-1.764Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__N)">
          <rect
            width={20}
            height={20}
            x={266.5}
            y={276}
            fill="url(#icon-melbourne-minimap-markers_svg__O)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__P)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m272.634 283.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm3.022 5.688v-1.188h1.392v.768l.468.456h2.28l.468-.456v-1.524l-.444-.444h-2.4v-1.2h2.4l.444-.444v-1.476l-.468-.456h-2.208l-.468.456v.768h-1.392v-1.188l1.236-1.236h3.456l1.236 1.236v2.304l-.648.636.648.648v2.34L280.42 290h-3.528l-1.236-1.236Z"
            />
          </g>
        </g>
        <g filter="url(#icon-melbourne-minimap-markers_svg__Q)">
          <rect
            width={20}
            height={20}
            x={238.5}
            y={335}
            fill="url(#icon-melbourne-minimap-markers_svg__R)"
            rx={10}
          />
          <g filter="url(#icon-melbourne-minimap-markers_svg__S)">
            <path
              fill="#000"
              fillOpacity={0.8}
              d="m244.774 342.076-1.836.948v-1.284l2.076-1.14h1.152v8.4h-1.392v-6.924Zm6.802 5.316h-4.08v-1.572l3.684-5.22h1.788v5.592h1.02v1.2h-1.02V349h-1.392v-1.608Zm.048-1.164v-4.152h-.06l-2.712 3.876v.276h2.772Z"
            />
          </g>
        </g>
      </g>
      <defs>
        <filter
          id="icon-melbourne-minimap-markers_svg__c"
          width={89.237}
          height={89.237}
          x={107.5}
          y={237}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1.5} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={3}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={4} />
          <feGaussianBlur stdDeviation={4} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__d"
          width={36}
          height={36}
          x={86.5}
          y={237}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__f"
          width={19.227}
          height={24.4}
          x={94.491}
          y={242.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__g"
          width={36}
          height={36}
          x={116.5}
          y={186}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__i"
          width={21.831}
          height={24.4}
          x={123.457}
          y={191.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__j"
          width={36}
          height={36}
          x={-0.5}
          y={132}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__l"
          width={22}
          height={24.4}
          x={6.287}
          y={137.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__m"
          width={36}
          height={36}
          x={59.5}
          y={126}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__o"
          width={22.492}
          height={24.4}
          x={66.127}
          y={131.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__p"
          width={36}
          height={36}
          x={17.5}
          y={66}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__r"
          width={21.977}
          height={24.4}
          x={24.389}
          y={71.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__s"
          width={36}
          height={36}
          x={104.5}
          y={13}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__u"
          width={22.048}
          height={24.4}
          x={111.409}
          y={18.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__v"
          width={36}
          height={36}
          x={188.5}
          y={93}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__x"
          width={22.24}
          height={24.4}
          x={195.256}
          y={98.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__y"
          width={36}
          height={36}
          x={131.5}
          y={59}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__A"
          width={21.688}
          height={24.4}
          x={138.413}
          y={64.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__B"
          width={36}
          height={36}
          x={230.5}
          y={231}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__D"
          width={22.048}
          height={24.4}
          x={237.32}
          y={236.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__E"
          width={36}
          height={36}
          x={268.5}
          y={192}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__G"
          width={27.386}
          height={24.4}
          x={272.505}
          y={197.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__H"
          width={36}
          height={36}
          x={338.5}
          y={324}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__J"
          width={23.966}
          height={24.4}
          x={344.122}
          y={329.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__K"
          width={36}
          height={36}
          x={277.5}
          y={332}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__M"
          width={26.689}
          height={24.4}
          x={281.968}
          y={337.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__N"
          width={36}
          height={36}
          x={258.5}
          y={270}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__P"
          width={26.858}
          height={24.4}
          x={262.798}
          y={275.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__Q"
          width={36}
          height={36}
          x={230.5}
          y={329}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <filter
          id="icon-melbourne-minimap-markers_svg__S"
          width={27.05}
          height={24.4}
          x={234.938}
          y={334.6}
          colorInterpolationFilters="sRGB"
          filterUnits="userSpaceOnUse"
        >
          <feFlood floodOpacity={0} result="BackgroundImageFix" />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feOffset dy={1} />
          <feGaussianBlur stdDeviation={1} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0" />
          <feBlend
            in2="BackgroundImageFix"
            result="effect1_dropShadow_9632_26856"
          />
          <feColorMatrix
            in="SourceAlpha"
            result="hardAlpha"
            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          />
          <feMorphology
            in="SourceAlpha"
            operator="dilate"
            radius={2}
            result="effect2_dropShadow_9632_26856"
          />
          <feOffset dy={2} />
          <feGaussianBlur stdDeviation={3} />
          <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0" />
          <feBlend
            in2="effect1_dropShadow_9632_26856"
            result="effect2_dropShadow_9632_26856"
          />
          <feBlend
            in="SourceGraphic"
            in2="effect2_dropShadow_9632_26856"
            result="shape"
          />
        </filter>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__b"
          x1={57.065}
          x2={318.734}
          y1={231.875}
          y2={165.299}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#4FC5BA" />
          <stop offset={1} stopColor="#4FC5BA" stopOpacity={0} />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__e"
          x1={114.5}
          x2={94.5}
          y1={243}
          y2={263}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__h"
          x1={144.5}
          x2={124.5}
          y1={192}
          y2={212}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__k"
          x1={27.5}
          x2={7.5}
          y1={138}
          y2={158}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__n"
          x1={87.5}
          x2={67.5}
          y1={132}
          y2={152}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__q"
          x1={45.5}
          x2={25.5}
          y1={72}
          y2={92}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__t"
          x1={132.5}
          x2={112.5}
          y1={19}
          y2={39}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__w"
          x1={216.5}
          x2={196.5}
          y1={99}
          y2={119}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__z"
          x1={159.5}
          x2={139.5}
          y1={65}
          y2={85}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__C"
          x1={258.5}
          x2={238.5}
          y1={237}
          y2={257}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__F"
          x1={296.5}
          x2={276.5}
          y1={198}
          y2={218}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__I"
          x1={366.5}
          x2={346.5}
          y1={330}
          y2={350}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__L"
          x1={305.5}
          x2={285.5}
          y1={338}
          y2={358}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__O"
          x1={286.5}
          x2={266.5}
          y1={276}
          y2={296}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <linearGradient
          id="icon-melbourne-minimap-markers_svg__R"
          x1={258.5}
          x2={238.5}
          y1={335}
          y2={355}
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#6DF1E5" />
          <stop offset={0.18} stopColor="#4FC5BA" />
          <stop offset={0.73} stopColor="#26A69A" />
          <stop offset={1} stopColor="#1A746B" />
        </linearGradient>
        <clipPath id="icon-melbourne-minimap-markers_svg__a">
          <path fill="#fff" d="M.5 0h375v375H.5z" />
        </clipPath>
      </defs>
    </svg>
  )
);
export default SvgIconMelbourneMinimapMarkers;
